/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.hosting.getAccountHistory'

export { $nsid }

/** Get account history, e.g. log of updated email addresses or other identity information. */
const main = l.query(
  $nsid,
  l.params({
    did: l.string({ format: 'did' }),
    events: l.optional(
      l.array(
        l.string<{
          knownValues: [
            'accountCreated',
            'emailUpdated',
            'emailConfirmed',
            'passwordUpdated',
            'handleUpdated',
          ]
        }>(),
      ),
    ),
    cursor: l.optional(l.string()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    events: l.array(l.ref<Event>((() => event) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Event = {
  $type?: 'tools.ozone.hosting.getAccountHistory#event'
  details:
    | l.$Typed<AccountCreated>
    | l.$Typed<EmailUpdated>
    | l.$Typed<EmailConfirmed>
    | l.$Typed<PasswordUpdated>
    | l.$Typed<HandleUpdated>
    | l.Unknown$TypedObject
  createdBy: string
  createdAt: l.DatetimeString
}

export type { Event }

const event = l.typedObject<Event>(
  $nsid,
  'event',
  l.object({
    details: l.typedUnion(
      [
        l.typedRef<AccountCreated>((() => accountCreated) as any),
        l.typedRef<EmailUpdated>((() => emailUpdated) as any),
        l.typedRef<EmailConfirmed>((() => emailConfirmed) as any),
        l.typedRef<PasswordUpdated>((() => passwordUpdated) as any),
        l.typedRef<HandleUpdated>((() => handleUpdated) as any),
      ],
      false,
    ),
    createdBy: l.string(),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { event }

type AccountCreated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#accountCreated'
  email?: string
  handle?: l.HandleString
}

export type { AccountCreated }

const accountCreated = l.typedObject<AccountCreated>(
  $nsid,
  'accountCreated',
  l.object({
    email: l.optional(l.string()),
    handle: l.optional(l.string({ format: 'handle' })),
  }),
)

export { accountCreated }

type EmailUpdated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#emailUpdated'
  email: string
}

export type { EmailUpdated }

const emailUpdated = l.typedObject<EmailUpdated>(
  $nsid,
  'emailUpdated',
  l.object({ email: l.string() }),
)

export { emailUpdated }

type EmailConfirmed = {
  $type?: 'tools.ozone.hosting.getAccountHistory#emailConfirmed'
  email: string
}

export type { EmailConfirmed }

const emailConfirmed = l.typedObject<EmailConfirmed>(
  $nsid,
  'emailConfirmed',
  l.object({ email: l.string() }),
)

export { emailConfirmed }

type PasswordUpdated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#passwordUpdated'
}

export type { PasswordUpdated }

const passwordUpdated = l.typedObject<PasswordUpdated>(
  $nsid,
  'passwordUpdated',
  l.object({}),
)

export { passwordUpdated }

type HandleUpdated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#handleUpdated'
  handle: l.HandleString
}

export type { HandleUpdated }

const handleUpdated = l.typedObject<HandleUpdated>(
  $nsid,
  'handleUpdated',
  l.object({ handle: l.string({ format: 'handle' }) }),
)

export { handleUpdated }
